import * as React from 'react'

import { Layout as AntLayout } from 'antd'
import { Route, Switch } from 'react-router'
import Home from '../Home'
import Wallet from '../Wallet'
import Bills, { ViewBillModal, EditBillModal } from '../Bills'
import Payers, {
  AddPayerModal,
  EditPayerModal,
  ViewPayerModal,
} from '../Payers'
import Items, { AddItemModal, EditItemModal } from '../Items'
import styled from 'styled-components'
import TaxRates from '../TaxRates/Taxes'
import NavMenu from './NavMenu'
import Discs from '../Discounts/Discounts'

const StyledContent = styled(AntLayout.Content)`
  overflow: hidden;
  padding: 48px;
  height: calc(100% - ${props => props.theme.headerHeight}px);
`

const Sizer = styled.div`
  margin: auto;
  height: 100%;
  overflow: hidden;
`

const Layout = () => (
  <>
    <NavMenu />
    <ViewBillModal />
    <EditBillModal />
    <AddItemModal />
    <EditItemModal />
    <AddPayerModal />
    <EditPayerModal />
    <ViewPayerModal />
    <StyledContent>
      <Sizer>
        <Switch>
          <Route path="/bills/taxes" component={TaxRates} />
          <Route path="/bills/discounts" component={Discs} />
          <Route path="/bills/items" component={Items} />
          <Route path="/bills/payers" component={Payers} />
          <Route path="/bills" component={Bills} />
          <Route path="/wallet" component={Wallet} />
          <Route path="/" component={Home} />
        </Switch>
      </Sizer>
    </StyledContent>
  </>
)

export default Layout
